<span class="subtitle-1">
  {{ operation.operationType === typeOperationEnum.ActeDeGestion ? 'Acte de gestion' : 'Souscription' }}
  N°{{ index + 1 }}</span
  >
  @if (showDetails) {
    <span class="body-1">
      @if (
        operation.operationType === typeOperationEnum.ActeDeGestion && operation.operationConfig?.natureOperation?.libelle
        ) {
        - {{ operation.operationConfig?.natureOperation?.libelle }}
      }
      @if (
        operation.operationType === typeOperationEnum.Souscription &&
        (operation.produit?.nomTechniqueProduitBox || operation.produit?.nom)
        ) {
        - {{ operation.produit?.nomTechniqueProduitBox ?? operation.produit?.nom }}
      }
      @if (operation.montant) {
        -
        {{ operation.montant | currency: 'EUR' : 'symbol' : '1.0-2' }}
      }
    </span>
  }
